<template>
  <div class="license-agreement-modal">
    <div class="license-content">
      <h2>License Agreement</h2>
      <div class="license-text">
        <div v-if="showFullLicense" class="license-scroll">
          {{ licenseText }}
        </div>
        <div v-else class="license-summary">
          <p>By using this software, you agree to the terms of the Creative Commons
            Attribution-NonCommercial-NoDerivatives 4.0 International Public License.</p>
          <button class="view-full-btn" @click="showFullLicense = true">View Full License</button>
        </div>
      </div>

      <div class="agreement-form">
        <div class="checkbox-container">
          <input type="checkbox" id="agree-checkbox" v-model="licenseAgreed" />
          <label for="agree-checkbox">I agree to the terms and conditions</label>
        </div>

        <!-- Additional questions for logged-in users -->
        <div v-if="isLoggedIn" class="additional-questions">
          <div class="form-group">
            <label for="intended-use">What is the intended use for the software?</label>
            <textarea id="intended-use" v-model="intendedUse" rows="3"
              placeholder="Please describe how you plan to use the software">
            </textarea>
          </div>

          <div class="form-group">
            <label for="institution">What institution are you from?</label>
            <input type="text" id="institution" v-model="institution" placeholder="Enter your institution name" />
          </div>
        </div>

        <div class="button-container">
          <!-- <button class="cancel-btn" @click="cancel">Cancel</button> -->
          <button class="agree-btn" :disabled="!canProceed" @click="submitAgreement">
            Agree and Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authStore from "../store/auth-store";

export default {
  name: 'LicenseAgreement',
  props: {
    showModal: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      licenseText: "", // We'll load the full license text here
      licenseAgreed: false,
      intendedUse: "",
      institution: "",
      showFullLicense: false
    };
  },
  computed: {
    isLoggedIn() {
      return authStore.state.user != null;
    },
    canProceed() {
      if (!this.licenseAgreed) return false;

      if (this.isLoggedIn) {
        return this.intendedUse.trim() !== "" && this.institution.trim() !== "";
      }

      return true;
    },
    user() {
      return authStore.state.user;
    }
  },
  created() {
    // Load the license text from the file you provided
    this.licenseText = `By exercising the Licensed Rights (defined below), You accept and agree to be bound by the terms and conditions of this Creative Commons Attribution-NonCommercial-NoDerivatives 4.0 International Public License ("Public License"). To the extent this Public License may be interpreted as a contract, You are granted the Licensed Rights in consideration of Your acceptance of these terms and conditions, and the Licensor grants You such rights in consideration of benefits the Licensor receives from making the Licensed Material available under these terms and conditions.

Section 1 – Definitions.

Adapted Material means material subject to Copyright and Similar Rights that is derived from or based upon the Licensed Material and in which the Licensed Material is translated, altered, arranged, transformed, or otherwise modified in a manner requiring permission under the Copyright and Similar Rights held by the Licensor. For purposes of this Public License, where the Licensed Material is a musical work, performance, or sound recording, Adapted Material is always produced where the Licensed Material is synched in timed relation with a moving image.

Copyright and Similar Rights means copyright and/or similar rights closely related to copyright including, without limitation, performance, broadcast, sound recording, and Sui Generis Database Rights, without regard to how the rights are labeled or categorized. For purposes of this Public License, the rights specified in Section 2(b)(1)-(2) are not Copyright and Similar Rights.

Effective Technological Measures means those measures that, in the absence of proper authority, may not be circumvented under laws fulfilling obligations under Article 11 of the WIPO Copyright Treaty adopted on December 20, 1996, and/or similar international agreements.

Exceptions and Limitations means fair use, fair dealing, and/or any other exception or limitation to Copyright and Similar Rights that applies to Your use of the Licensed Material.

Licensed Material means the artistic or literary work, database, or other material to which the Licensor applied this Public License.

Licensed Rights means the rights granted to You subject to the terms and conditions of this Public License, which are limited to all Copyright and Similar Rights that apply to Your use of the Licensed Material and that the Licensor has authority to license.

Licensor means the individual(s) or entity(ies) granting rights under this Public License.

NonCommercial means not primarily intended for or directed towards commercial advantage or monetary compensation. For purposes of this Public License, the exchange of the Licensed Material for other material subject to Copyright and Similar Rights by digital file-sharing or similar means is NonCommercial provided there is no payment of monetary compensation in connection with the exchange.

Share means to provide material to the public by any means or process that requires permission under the Licensed Rights, such as reproduction, public display, public performance, distribution, dissemination, communication, or importation, and to make material available to the public including in ways that members of the public may access the material from a place and at a time individually chosen by them.

Sui Generis Database Rights means rights other than copyright resulting from Directive 96/9/EC of the European Parliament and of the Council of 11 March 1996 on the legal protection of databases, as amended and/or succeeded, as well as other essentially equivalent rights anywhere in the world.

You means the individual or entity exercising the Licensed Rights under this Public License. Your has a corresponding meaning.

Section 2 – Scope.

License grant.

Subject to the terms and conditions of this Public License, the Licensor hereby grants You a worldwide, royalty-free, non-sublicensable, non-exclusive, irrevocable license to exercise the Licensed Rights in the Licensed Material to:

reproduce and Share the Licensed Material, in whole or in part, for NonCommercial purposes only; and

produce and reproduce, but not Share, Adapted Material for NonCommercial purposes only.

Exceptions and Limitations. For the avoidance of doubt, where Exceptions and Limitations apply to Your use, this Public License does not apply, and You do not need to comply with its terms and conditions.

Term. The term of this Public License is specified in Section 6(a).

Media and formats; technical modifications allowed. The Licensor authorizes You to exercise the Licensed Rights in all media and formats whether now known or hereafter created, and to make technical modifications necessary to do so. The Licensor waives and/or agrees not to assert any right or authority to forbid You from making technical modifications necessary to exercise the Licensed Rights, including technical modifications necessary to circumvent Effective Technological Measures. For purposes of this Public License, simply making modifications authorized by this Section 2(a)(4) never produces Adapted Material.

Downstream recipients.

Offer from the Licensor – Licensed Material. Every recipient of the Licensed Material automatically receives an offer from the Licensor to exercise the Licensed Rights under the terms and conditions of this Public License.

No downstream restrictions. You may not offer or impose any additional or different terms or conditions on, or apply any Effective Technological Measures to, the Licensed Material if doing so restricts exercise of the Licensed Rights by any recipient of the Licensed Material.

No endorsement. Nothing in this Public License constitutes or may be construed as permission to assert or imply that You are, or that Your use of the Licensed Material is, connected with, or sponsored, endorsed, or granted official status by, the Licensor or others designated to receive attribution as provided in Section 3(a)(1)(A)(i).

Other rights.

Moral rights, such as the right of integrity, are not licensed under this Public License, nor are publicity, privacy, and/or other similar personality rights; however, to the extent possible, the Licensor waives and/or agrees not to assert any such rights held by the Licensor to the limited extent necessary to allow You to exercise the Licensed Rights, but not otherwise.

Patent and trademark rights are not licensed under this Public License.

To the extent possible, the Licensor waives any right to collect royalties from You for the exercise of the Licensed Rights, whether directly or through a collecting society under any voluntary or waivable statutory or compulsory licensing scheme. In all other cases the Licensor expressly reserves any right to collect such royalties, including when the Licensed Material is used other than for NonCommercial purposes.

Section 3 – License Conditions.

Your exercise of the Licensed Rights is expressly made subject to the following conditions.

Attribution.

If You Share the Licensed Material, You must:

retain the following if it is supplied by the Licensor with the Licensed Material:

identification of the creator(s) of the Licensed Material and any others designated to receive attribution, in any reasonable manner requested by the Licensor (including by pseudonym if designated);

a copyright notice;

a notice that refers to this Public License;

a notice that refers to the disclaimer of warranties;

a URI or hyperlink to the Licensed Material to the extent reasonably practicable;

indicate if You modified the Licensed Material and retain an indication of any previous modifications; and

indicate the Licensed Material is licensed under this Public License, and include the text of, or the URI or hyperlink to, this Public License.

For the avoidance of doubt, You do not have permission under this Public License to Share Adapted Material.

You may satisfy the conditions in Section 3(a)(1) in any reasonable manner based on the medium, means, and context in which You Share the Licensed Material. For example, it may be reasonable to satisfy the conditions by providing a URI or hyperlink to a resource that includes the required information.

If requested by the Licensor, You must remove any of the information required by Section 3(a)(1)(A) to the extent reasonably practicable.

Section 4 – Sui Generis Database Rights.

Where the Licensed Rights include Sui Generis Database Rights that apply to Your use of the Licensed Material:

for the avoidance of doubt, Section 2(a)(1) grants You the right to extract, reuse, reproduce, and Share all or a substantial portion of the contents of the database for NonCommercial purposes only and provided You do not Share Adapted Material;

if You include all or a substantial portion of the database contents in a database in which You have Sui Generis Database Rights, then the database in which You have Sui Generis Database Rights (but not its individual contents) is Adapted Material; and

You must comply with the conditions in Section 3(a) if You Share all or a substantial portion of the contents of the database.

For the avoidance of doubt, this Section 4 supplements and does not replace Your obligations under this Public License where the Licensed Rights include other Copyright and Similar Rights.

Section 5 – Disclaimer of Warranties and Limitation of Liability.

Unless otherwise separately undertaken by the Licensor, to the extent possible, the Licensor offers the Licensed Material as-is and as-available, and makes no representations or warranties of any kind concerning the Licensed Material, whether express, implied, statutory, or other. This includes, without limitation, warranties of title, merchantability, fitness for a particular purpose, non-infringement, absence of latent or other defects, accuracy, or the presence or absence of errors, whether or not known or discoverable. Where disclaimers of warranties are not allowed in full or in part, this disclaimer may not apply to You.

To the extent possible, in no event will the Licensor be liable to You on any legal theory (including, without limitation, negligence) or otherwise for any direct, special, indirect, incidental, consequential, punitive, exemplary, or other losses, costs, expenses, or damages arising out of this Public License or use of the Licensed Material, even if the Licensor has been advised of the possibility of such losses, costs, expenses, or damages. Where a limitation of liability is not allowed in full or in part, this limitation may not apply to You.

The disclaimer of warranties and limitation of liability provided above shall be interpreted in a manner that, to the extent possible, most closely approximates an absolute disclaimer and waiver of all liability.

Section 6 – Term and Termination.

This Public License applies for the term of the Copyright and Similar Rights licensed here. However, if You fail to comply with this Public License, then Your rights under this Public License terminate automatically.

Where Your right to use the Licensed Material has terminated under Section 6(a), it reinstates:

automatically as of the date the violation is cured, provided it is cured within 30 days of Your discovery of the violation; or

upon express reinstatement by the Licensor.

For the avoidance of doubt, this Section 6(b) does not affect any right the Licensor may have to seek remedies for Your violations of this Public License.

For the avoidance of doubt, the Licensor may also offer the Licensed Material under separate terms or conditions or stop distributing the Licensed Material at any time; however, doing so will not terminate this Public License.

Sections 1, 5, 6, 7, and 8 survive termination of this Public License.

Section 7 – Other Terms and Conditions.

The Licensor shall not be bound by any additional or different terms or conditions communicated by You unless expressly agreed.

Any arrangements, understandings, or agreements regarding the Licensed Material not stated herein are separate from and independent of the terms and conditions of this Public License.

Section 8 – Interpretation.

For the avoidance of doubt, this Public License does not, and shall not be interpreted to, reduce, limit, restrict, or impose conditions on any use of the Licensed Material that could lawfully be made without permission under this Public License.

To the extent possible, if any provision of this Public License is deemed unenforceable, it shall be automatically reformed to the minimum extent necessary to make it enforceable. If the provision cannot be reformed, it shall be severed from this Public License without affecting the enforceability of the remaining terms and conditions.

No term or condition of this Public License will be waived and no failure to comply consented to unless expressly agreed to by the Licensor.

Nothing in this Public License constitutes or may be interpreted as a limitation upon, or waiver of, any privileges and immunities that apply to the Licensor or You, including from the legal processes of any jurisdiction or authority.`;

    // Check if user has already agreed
    if (this.isLoggedIn) {
      // For logged-in users, check the user object
      if (this.user && this.user.agreedTcs) {
        this.$emit('agreement-complete');
      }
    } else {
      // For non-logged in users, check localStorage
      const hasAgreed = localStorage.getItem("@license-agreed") === "true";
      if (hasAgreed) {
        this.$emit('agreement-complete');
      }
    }
  },
  methods: {
    submitAgreement() {
      if (!this.canProceed) return;

      if (this.isLoggedIn) {
        // Save agreement to backend for logged-in users
        this.saveAgreementToBackend();
      } else {
        // Save agreement in localStorage for guests
        localStorage.setItem("@license-agreed", "true");
        this.$emit('agreement-complete');
      }
    },
    async saveAgreementToBackend() {
      try {
        const response = await this.axios.post("/api/auth/updateTcs", {
          agreedTcs: true,
          intendedUse: this.intendedUse,
          institution: this.institution
        }, {
          headers: {
            'Authorization': 'Bearer ' + this.user.token
          }
        });

        if (response.status === 200) {
          // Update local user state to reflect agreement
          const updatedUser = { ...this.user, agreedTcs: true };
          authStore.commit('setUser', updatedUser);
          this.$emit('agreement-complete');
        }
      } catch (error) {
        console.error("Error saving license agreement:", error);
        alert("There was an error saving your agreement. Please try again.");
      }
    },
    cancel() {
      this.$emit('cancel');
    }
  }
};
</script>

<style lang="scss" scoped>
.license-agreement-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.license-content {
  background-color: white;
  border-radius: 5px;
  width: 90%;
  max-width: 700px;
  max-height: 90vh;
  padding: 20px;
  overflow-y: auto;

  h2 {
    margin-top: 0;
    color: #013B82;
    margin-bottom: 20px;
  }
}

.license-text {
  margin-bottom: 20px;
}

.license-scroll {
  max-height: 300px;
  overflow-y: auto;
  padding: 10px;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  margin-bottom: 15px;
  white-space: pre-line;
  font-size: 14px;
  line-height: 1.5;
}

.license-summary {
  margin-bottom: 15px;
}

.view-full-btn {
  background-color: transparent;
  border: 1px solid #013B82;
  color: #013B82;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;

  &:hover {
    background-color: #f0f0f0;
  }
}

.agreement-form {
  .checkbox-container {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    input {
      margin-right: 10px;
    }
  }

  .form-group {
    margin-bottom: 15px;

    label {
      display: block;
      margin-bottom: 5px;
      font-weight: bold;
    }

    input,
    textarea {
      width: 100%;
      padding: 8px;
      border: 1px solid #ccc;
      border-radius: 4px;
    }
  }
}

.additional-questions {
  background-color: #f8f9fa;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 15px;
}

.button-container {
  display: flex;
  justify-content: flex-end;
  gap: 10px;

  button {
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
  }

  .cancel-btn {
    background-color: transparent;
    border: 1px solid #ccc;

    &:hover {
      background-color: #f0f0f0;
    }
  }

  .agree-btn {
    background-color: #013B82;
    border: none;
    color: white;

    &:hover {
      background-color: #0056b3;
    }

    &:disabled {
      background-color: #cccccc;
      cursor: not-allowed;
    }
  }
}
</style>